<template>

    <div class="root"></div>

</template>

<script>

    export default {

        name: 'BreakpointDebugger',

        data() {
            return {

            };
        }

    };

</script>

<style lang="scss" scoped>

    .root {
        background-color: rgba(255,255,255, 1.0); // WHITE
        width: 100%;
        height: 3px;
        box-shadow: 0 0 3px rgba(0,0,0, 0.9);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        pointer-events: none;
        transition: all 0.3s ease-in-out;

        // Small devices (landscape phones, 576px and up) RED
        @media (min-width: 576px) {
            background-color: rgba(237,18,18, 1.0);
        }

        // Medium devices (tablets, 768px and up) GREEN
        @media (min-width: 768px) {
            background-color: rgba(66,163,60, 1.0);
        }

        // Large devices (desktops, 992px and up) BLUE
        @media (min-width: 992px) {
            background-color: rgba(30,144,255, 1.0);
        }

        // Extra large devices (large desktops, 1200px and up) YELLOW
        @media (min-width: 1200px) {
            background-color: rgba(230,232,69, 1.0);
        }

        // X-Extra large devices (large desktops, 1900px and up) PURPLE
        @media (min-width: 1900px) {
            background-color: rgba(128,0,128, 1.0);
        }
    }

</style>
